// extracted by mini-css-extract-plugin
module.exports = {"header":"_5D32fgNA","top":"_5DNVma7v","icon":"_5D30E11L","titles":"_5D28lRXF","title":"_5D3zcxFp","subtitle":"_5D1jgD5v","description":"_5D6kCm05","image":"_5D1OgsG3"};